import styles from './TableNavFilter.module.scss';

type TableNavFilterProps = {
  label: string;
  status?: 'Default' | 'Hover' | 'Active' | 'Disabled';
  onClick?: () => void;
};

const TableNavFilter = ({ label, status = 'Default', onClick }: TableNavFilterProps) => {
  return (
    <button
      className={`${styles['nav-item']} ${styles[status]}`}
      onClick={onClick}
      disabled={status === 'Disabled'}
    >
      {label}
    </button>
  );
};
export default TableNavFilter;
